module.exports = __webpack_public_path__ + "static/media/receiving-place-icon.a15bd863.svg";